import request from 'utils/request'

/**
 * 获取账期调整审批记录列表
 * @param {*} data
 */
export const getApproveRecordList = data =>
  request().post('bp/approveTermRecordList/pageAll', data)

  export const periodExportList = data =>
  request().post('bp/approveTermRecordList/exportAll', data, {
    responseType: 'arraybuffer',
  })

/**
 * 获取延期审批历史记录列表
 * @param {*} data
 */
export const getExtensionRecordList = data =>
  request().post('limit/approve/pageAll', data)

export const extensionExportList = data =>
  request().post('limit/approve/exportAll', data, {
    responseType: 'arraybuffer',
  })

export const getBatchRecordList = data =>
  request().post('periodBatch/approve/pageAll', data)

export const exportRecord = data =>
  request().post('periodBatch/approve/exportAll', data, {
    responseType: 'arraybuffer',
  })

export const getBatchExtensionRecordList = data =>
  request().post('limit/batch/approve/pageAll', data)

export const extensionExportRecord = data =>
  request().post('limit/batch/approve/exportAll', data, {
    responseType: 'arraybuffer',
  })

export const getCreditManagers = () => request().get('bp/apply/listCManager')